import React from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import "swiper/swiper-bundle.css";

import "./ClientSwiper.css";
SwiperCore.use([Navigation, Pagination, Autoplay]);
const ClientSwiper = () => {
    const customPrevButton = (
        <IoIosArrowBack size={30} color="#333" className="swiper-button-prev" />
    );

    const customNextButton = (
        <IoIosArrowForward size={30} color="#333" className="swiper-button-next" />
    );

    return (
        <Swiper
            navigation={{
                prevEl: ".swiper-button-prev",
                nextEl: ".swiper-button-next",
            }}
            pagination={{ clickable: true }}
            loop
            speed={1000}
            autoplay={{ delay: 1000 }} // Set autoplay delay to 1 second
            className="swiper2 p-8 my-4"
        >
            <SwiperSlide>
                {/* <img src="https://images.pexels.com/photos/3785417/pexels-photo-3785417.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="client_photo" style={{ width: '80px', height: '80px' }} className='rounded-full mx-auto' /> */}
                <p className='px-12 mt-6 text-sm md:text-lg mx-auto rtl font-medium max-w-[400px] lg:max-w-[600px] text-main' dir='rtl'>
                "הזמנתי ארון לחדר של הילדים ויצא בול כמו שרציתי! 
מחולק נכון פלוס סגירה של הארון עד לתקר כמו שביקשתי. שירות ותוצאה ברמה הכי גבוהה שיש"
                </p>
                <p className='text-sm mx-auto rtl font-bold text-clientName mt-2' dir='rtl'>
                    ליאת
                </p>
            </SwiperSlide>

            <SwiperSlide>
                {/* <img src="https://images.pexels.com/photos/3785417/pexels-photo-3785417.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="client_photo" style={{ width: '80px', height: '80px' }} className='rounded-full mx-auto' /> */}
                <p className='px-12 mt-6 text-sm md:text-lg mx-auto rtl font-medium max-w-[400px] lg:max-w-[600px] text-main' dir='rtl'>
                "שירות אדיב ומעולה ארונות ברמה גבוהה בהתאמה אישית . ממליצה בחום"
                </p>
                <p className='text-sm mx-auto rtl font-bold text-clientName mt-2' dir='rtl'>
                    מאיה
                </p>
            </SwiperSlide>

            <SwiperSlide>
                {/* <img src="https://images.pexels.com/photos/3785417/pexels-photo-3785417.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="client_photo" style={{ width: '80px', height: '80px' }} className='rounded-full mx-auto' /> */}
                <p className='px-12 mt-6 text-sm md:text-lg mx-auto rtl font-medium max-w-[400px] lg:max-w-[600px] text-main' dir='rtl'>
                "מקום מספר אחת יחס, מחיר ושירות !
אין עליכם אין ספק שנבוא אליכם שוב !
תודה רבה על הכל"
                </p>
                <p className='text-sm mx-auto rtl font-bold text-clientName mt-2' dir='rtl'>
                    דניאל
                </p>
            </SwiperSlide>

            <SwiperSlide>
                {/* <img src="https://images.pexels.com/photos/3785417/pexels-photo-3785417.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="client_photo" style={{ width: '80px', height: '80px' }} className='rounded-full mx-auto' /> */}
                <p className='px-12 mt-6 text-sm md:text-lg mx-auto rtl font-medium max-w-[400px] lg:max-w-[600px] text-main' dir='rtl'>
                "שירות, מקצועיות, יחס אישי, ממליצה בחום"
                </p>
                <p className='text-sm mx-auto rtl font-bold text-clientName mt-2' dir='rtl'>
                    נועם    
                </p>
            </SwiperSlide>

            <SwiperSlide>
                {/* <img src="https://images.pexels.com/photos/3785417/pexels-photo-3785417.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="client_photo" style={{ width: '80px', height: '80px' }} className='rounded-full mx-auto' /> */}
                <p className='px-12 mt-6 text-sm md:text-lg mx-auto rtl font-medium max-w-[400px] lg:max-w-[600px] text-main' dir='rtl'>
                "אלופים הן בשירות והן במחיר"
                </p>
                <p className='text-sm mx-auto rtl font-bold text-clientName mt-2' dir='rtl'>
                    משה
                </p>
            </SwiperSlide>


            <div className="swiper-button-prev-custom">{customPrevButton}</div>
            <div className="swiper-button-next-custom">{customNextButton}</div>
        </Swiper>
    );
}

export default ClientSwiper